import './index.scss'

const About = () => {
    return (
        <div className='about-page container'>
            <head>About</head>
            <div className='text-zone'>
                <h1>About</h1>
                <p>I am a recent college graduate with experience in Data Analysis as well as building small Deep Learning, Blockchain, and AI projects. 
                While I have a passion for working data and AI, I also have Frontend and Backend experience from developing iOS apps and small websites.</p>
                <figure>
                    <figcaption>Skills:</figcaption>
                    <ul>
                        <li>Python (Tensorflow, scikit-learn, Pandas, NumPy, Flask)</li>
                        <li>C++, Java</li>
                        <li>Javascript, HTML, CSS (React.js)</li>
                        <li>Swift (Mobile UI Design, Backend, Frontend)</li>
                        <li>SQL (SQL Server)</li>
                        <li>Bash (Scripting)</li>
                        <li>Tableau</li>
                    </ul>
                </figure>
                <figure>
                    <figcaption>Education:</figcaption>
                    <ul>
                        <li>BA in Computer Science, Hunter College, Spring 2022 (Google Student Developers Club)</li>
                        <li>The Beacon High School</li>
                    </ul>
                </figure>
                <figure>
                    <figcaption>Interests:</figcaption>
                    <ul>
                        <li>Playing and writing music</li>
                        <li>Calesthenics</li>
                        <li>Fashion</li>
                    </ul>
                </figure>
            </div>
        </div>
    )
}

export default About